import { render, staticRenderFns } from "./GmbLogList.vue?vue&type=template&id=122ba2be&scoped=true&"
import script from "./GmbLogList.vue?vue&type=script&lang=js&"
export * from "./GmbLogList.vue?vue&type=script&lang=js&"
import style0 from "./GmbLogList.vue?vue&type=style&index=0&id=122ba2be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122ba2be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('122ba2be')) {
      api.createRecord('122ba2be', component.options)
    } else {
      api.reload('122ba2be', component.options)
    }
    module.hot.accept("./GmbLogList.vue?vue&type=template&id=122ba2be&scoped=true&", function () {
      api.rerender('122ba2be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gmbs/GmbLogList.vue"
export default component.exports